import { defineComponent as _defineComponent } from 'vue'
import { formatDate } from '@/util/global';
import NDrawer from '@/component/NDrawer/NDrawer.vue';
import { computed, getCurrentInstance, onBeforeMount, onMounted, ref } from 'vue';
import NSchedule, { ScheduleProps } from '@/component/NSchedule/NSchedule.vue';
import ViewImg from '@/component/ViewImg/ViewImg.vue';
import { getOrderDetail, getOrderLog, setOrderLog } from '@/api/order/order-list';
import ViewImgGroup from '@/component/ViewImg/ViewImgGroup.vue';
import { useRouter } from '@/router';
import { confirmRefund } from '@/api/order/refund';
import { message } from 'ant-design-vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RefundDetil',
  props: {
    id: null
  },
  emits: ['change'],
  setup(__props: any, { emit }) {

const props = __props as {
  id: number;
};

const router = useRouter();
const REASON_FOR_THE_CREDIT = [
  {
    id: 0,
    value: '全部',
  },
  {
    id: 1,
    value: '商品质量有问题',
  },
  {
    id: 2,
    value: '漏发/错发',
  },
  {
    id: 3,
    value: '不想要了',
  },
  {
    id: 4,
    value: '其他原因',
  },
];

let isChange = false

const detail = ref<any>({});
const show_refund_modal = ref(false);
const refuse_modal = ref(false);
const refuse_refund_reason = ref('');
const visible = ref<boolean>(false);
const img_url_list = ref([]);
const steps = computed<ScheduleProps['status']>(() => {
  if (detail.value?.refund?.length > 0) {
    const { create_time = 0, check_time = 0, refund_time = 0, status } = detail.value?.refund?.[0];
    return [
      {
        title: `申请退款`,
        date: create_time ? formatDate(create_time) : '',
        isOpen: create_time,
      },
      {
        title: `处理中`,
        date: check_time ? formatDate(check_time) : '',
        isOpen: check_time,
        style: create_time ? { backgroundColor: '#375ed3', borderColor: '#a7b8ed' } : undefined,

      },
      {
        title: `系统退款`,
        date: refund_time ? formatDate(refund_time) : '',
        isOpen: refund_time,
        style: status == 3 ? { backgroundColor: '#FF0000', borderColor: '#FFaaaa' } : undefined,
      },
      {
        title: `退款成功`,
        date: refund_time ? formatDate(refund_time) : '',
        isOpen: refund_time,
        style: status == 3 ? { backgroundColor: '#FF0000', borderColor: '#FFaaaa' } : undefined,
      },
    ];
  }
  const { paid_time = 0, delivery_time = 0, confirmed_time = 0 } = detail.value;
  return [
    {
      title: `${paid_time ? '已' : '待'}支付`,
      date: paid_time ? formatDate(paid_time) : '',
      isOpen:detail.value?.status==1|| paid_time ,
    },
    {
      title: `${delivery_time ? '已' : '待'}发货`,
      date: delivery_time ? formatDate(delivery_time) : '',
      isOpen: delivery_time,
    },
    {
      title: `${confirmed_time ? '已' : '待'}收货`,
      date: confirmed_time ? formatDate(confirmed_time) : '',
      isOpen: confirmed_time,
    },
  ];
});
function onClose() {
  visible.value = false;
  if(isChange){
    emit('change')
  }
  if (router.currentRoute.name) {
    router.push({
      name: router.currentRoute.name,
    });
  }
}
async function onOpen() {
  if (router.currentRoute.name) {
    router.push({
      name: router.currentRoute.name,
      query: {
        order_id: String(props.id),
      },
    });
  }

  visible.value = true;
  if (props.id) {
    getFollow(props.id);
    const res = await getOrderDetail(props.id);
    if (!res) {
      return;
    }
    detail.value = res;
  }
}

const follow = ref<any[]>([]);
const followInfo = ref<any>('');
const followLoading = ref<boolean>(false);
async function getFollow(id) {
  followLoading.value = true;
  const res = await getOrderLog(id);
  followLoading.value = false;
  if (res.detail) {
    follow.value = res.detail;
  }
}

function addFollow() {
  if (!followInfo.value) {
    return;
  }
  followLoading.value = true;
  setOrderLog(props.id, followInfo.value).then(() => {
    followInfo.value = '';
    followLoading.value = false;
    onOpen();
  });
  onOpen();
}
async function confirm_refund() {
  const data_id = detail.value.refund[0].id;
  const res: any = await confirmRefund(data_id, { type: 'agree' });
  if (res.status !== 200) {
    message.error('退款失败');
    return;
  }
  message.success('退款成功');
  show_refund_modal.value = false;
  onOpen();
  isChange = true
}
//确认拒绝退款
async function confirm_refuse() {
  if (!refuse_refund_reason.value) {
    message.error('请输入拒绝退款原因');
    return;
  }
  const send_data = {
    type: 'disagree',
    reason_image_url: img_url_list.value.length === 0 ? '' : img_url_list.value.join(','),
    reason: refuse_refund_reason.value,
  };
  const data_id = detail.value.refund[0].id;
  const res: any = await confirmRefund(data_id, send_data);
  if (res.status !== 200) {
    message.error('拒绝退款失败');
    return;
  }
  img_url_list.value = [];
  message.success('拒绝退款成功');
  refuse_modal.value = false;
  onOpen();
  isChange = true
}
function beforeCommonUpload(file: any) {
  if (file.size / 1024 / 1024 > 2) {
    message.error('上传图片大小不能超过2M');
    return false;
  }
}
const drawerRef = ref();
onMounted(() => {
  // 处理ant表格操作列导致的多次渲染bug
  const _this = getCurrentInstance();
  if (_this) {
    //判断当前节点的父级是否是ant table产生的虚拟节点，如果是则移除该组件
    for (const className of _this?.proxy?.$parent?.$el.classList || []) {
      if (className == 'ant-table-fixed-columns-in-body') {
        _this?.proxy?.$parent?.$el?.remove();
        getCurrentInstance()?.proxy?.$destroy();
        return;
      }
    }
  }

  if (router.currentRoute.query) {
    const order_id = String(router.currentRoute.query.order_id);
    if (order_id == String(props.id)) {
      drawerRef.value.open();
      console.log('打开');
    }
  }
});

return { __sfc: true,router, REASON_FOR_THE_CREDIT, props, isChange, emit, detail, show_refund_modal, refuse_modal, refuse_refund_reason, visible, img_url_list, steps, onClose, onOpen, follow, followInfo, followLoading, getFollow, addFollow, confirm_refund, confirm_refuse, beforeCommonUpload, drawerRef, formatDate, NDrawer, NSchedule, ViewImg, ViewImgGroup, MultipleImageUpload }
}

})